import adapter from '../../../adapters/new-contract';
import buildPdsUrlNewContract from '../build-pds-url-new-contract';
import { RequestParams, AdaptedResponse, Data } from './types';

export default async (
  productsUrl: string,
  parameters: RequestParams
): Promise<AdaptedResponse> => {
  const request = buildPdsUrlNewContract({ ...parameters, productsUrl });
  const data = await fetch(request);
  const jsonData: Data = await data.json();
  const fetchDataResponse = adapter(jsonData);

  return fetchDataResponse;
};
